import React from "react";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next/hooks";
import Img from "react-cool-img";

import Loader from "../../Loader/Loader";
import GroupTalkTextItem from "./GroupTalkTextItem/GroupTalkTextItem";

import { useStore } from '../../../hook-store/store';
import { getRandomBgColor } from "../../../util/color-style";

import classes from "./GroupTalkTextList.module.css";

import SampleImage from "../../Image/person-icon-50.jpg";


const GroupTalkTextList = (props) => {
  // console.log('GroupTalkTextList-props', props);
  const {
    userId,
    allMemberUserIds,
    groupTextReactions,
    createGroupTextReactionHandler,
    groupTextDeleteHandler,
    showGroupTextInputElement,
    groupTextPostHandler,
    isTextPosting,
    isLoading,
  } = props;

  const [t] = useTranslation("translation");

  const ref = useRef(null);
  const textListRef = useRef({});

  const [store, dispatch] = useStore();
  const { 
    selectedGroupData,
    groupPostScrollFailData,
  } = store.groupStore;

  let groupTalkInputList = [];

  if (selectedGroupData && selectedGroupData.talks && 
    selectedGroupData.talks.length > 0
  ) {
    groupTalkInputList = selectedGroupData.talks;
  }

  // console.log('groupTalkInputList', groupTalkInputList)

  // const [isGroupMember, setIsGroupMember] = useState(false);
  const [getMoreNum, setGetMoreNum] = useState(1);
  const [isMoreText, setIsMoreText] = useState(true);
  const [textTalkScroll, setTextTalkScroll] = useState(-1);
  const [userColorList, setUserColorList] = useState([]);
  const [latestText, setLatestText] = useState();

  const lsNameDataList = localStorage.getItem('lsNameDataList');

  // useEffect(() => {
  //   // var div = document.getElementById('text-talk');
  //   // console.log('div', div);
  //   scrollToBottom("text-talk");
  // }, [groupTalkInputList.length]);

  
  //// scroll to bottom when page loaded
  useEffect(() => {
    scrollToBottom("text-talk");
  }, []);

  //// show notify when post is added.
  useEffect(() => {
    if (groupTalkInputList && groupTalkInputList.length > 0) {
      const storeLatestText = groupTalkInputList[groupTalkInputList.length - 1];
      
      if (latestText && storeLatestText
          && storeLatestText.sendAt > latestText.sendAt
      ) {
        showNewPostNotifyHandler(storeLatestText, userId);
      }

      setLatestText(storeLatestText);

    } else {
      setLatestText(null);
    }

  }, [groupTalkInputList.length]);


  useEffect(() => {
    if (allMemberUserIds.length > 0) {
      setUserColorList(generateRandomUserColorList(allMemberUserIds));
    }
  }, [allMemberUserIds]);



  useEffect(() => {
    const memberList = allMemberUserIds;
    let noMemberInterval;

    if (memberList && memberList.length > 0) {
      const isMember = memberList.find(member => {
        return member.userId === userId;
      });

      if (isMember) {
        dispatch('SET_ISGROUPMEMBER', true);
      }

      
      if (!isMember) {
        noMemberInterval = setInterval(() => {
          console.log('inside setInterval')
        }, 1000 * 60 * 5);
      }

    }

    return () => {
      clearInterval(noMemberInterval);
      dispatch('SET_ISGROUPMEMBER', false);
    }
    

  },[allMemberUserIds]);


  useEffect(() => {
    if (getMoreNum >= 2) {
      scrollToRef();
    }

    let isMoreText = false;
  
    if (groupTalkInputList.length > initialLength*getMoreNum) {
      isMoreText = true;
    }

    setIsMoreText(isMoreText);


  },[getMoreNum, groupTalkInputList]);




  useEffect(() => {
    const textTalkEl = document.getElementById('text-talk');
    // console.log('refl testTalkEl', textTalkEl)
    
    if (textTalkEl) {
      // console.log('refl ', textTalkEl.target)
      textTalkEl.addEventListener('scroll', (event) => {
        // console.log('refl', textTalkEl.scrollTop, isMoreText, getMoreNum);
        setTextTalkScroll(textTalkEl.scrollTop);
      });
    }
  },[]);


  useEffect(() => {
    if (textTalkScroll === 0 && isMoreText) {
      setGetMoreNum(getMoreNum+1);
    }
  },[textTalkScroll]);


  // //// initialize selectedKuraFileData when leave textList
  // useEffect(() => {
  //   return (() => {
  //     dispatch('SET_SELECTEDKURAFILEDATA', null);
  //   })
  // },[]);

  useEffect(() => {
    dispatch('SET_GROUPTEXTITEMREF', textListRef);
  },[textListRef])


  const scrollToTop = (id) => {
    var div = document.getElementById(id);
    if (div) {
      div.scrollTop = 0;
    }
  };

  const scrollToBottom = (id) => {
    var div = document.getElementById(id);
    if (div) {
      div.scrollTop = div.scrollHeight - div.clientHeight;
    }
  };


  const scrollToRef = () => {
    ref.current.scrollIntoView({
      // behavior: 'smooth',
      // block: 'center',
    });
  };

  const showNewPostNotifyHandler = (storeLatestText, userId) => {
    if (storeLatestText.fromUserId === userId) {
      dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: 'post added',
          message: '',
        });
  
        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000 * 5);
    } else {

      let postUserNameData;

      if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
        postUserNameData = JSON.parse(lsNameDataList).find(ele => {
          return ele.userId === storeLatestText.fromUserId;
        });
      }

      let notifyTitle = (<span>New post added</span>);
      let notifyContent = '';

      if (postUserNameData) {
        notifyContent = (
          <span>
            <div className={classes.groupTextListNotifyText}>
              {storeLatestText.text && storeLatestText.text.length > 50 && (
                <span>{storeLatestText.text.slice(0,50)}....</span>
              )}
              {storeLatestText.text && storeLatestText.text.length <= 50 && (
                <span>{storeLatestText.text}</span>
              )}
            </div>
            <div className={classes.groupTextListNotifyNameRow}>
              <span>
                {postUserNameData.name}
              </span>
              {postUserNameData.imageUrl && (
                <Img 
                  className={classes.groupTextListNotifyNameImage}
                  title={postUserNameData.name}
                  src={postUserNameData.imageUrl} 
                />
              )}
              {!postUserNameData.imageUrl && (
                <Img 
                  className={classes.groupTextListNotifyNameImage}
                  title={postUserNameData.name}
                  src={SampleImage} 
                />
              )}
            </div>
          </span>
        );
      }

      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: notifyTitle,
        message: notifyContent,
      });

      setTimeout(() => {
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 10);
    }
  };


  const lsUsersColorInfo = JSON.parse(localStorage.getItem("groupColorInfo"));

  if (!lsUsersColorInfo) {
    localStorage.setItem("groupColorInfo", JSON.stringify([{}]));
  }

  function generateRandomUserColorList(memberList) {

    const bgColorArray = [];
    // for (var i = number; i--;) {
    //   bgColorArray.push(getRandomBgColor());
    // }

    for (const member of memberList) {
      if (lsUsersColorInfo && lsUsersColorInfo.length > 0) {
        let addedList = lsUsersColorInfo;

        const lsUser = lsUsersColorInfo.find((element) => {
          return element.userId === member.userId;
        });
        // console.log("lsUser", lsUser);

        if (lsUser) {
          bgColorArray.push({
            userId: member.userId,
            bgColor: lsUser.bgColor,
          });
        } else {
          bgColorArray.push({
            userId: member.userId,
            bgColor: getRandomBgColor(),
          });

          addedList = lsUsersColorInfo.concat({
            userId: member.userId,
            bgColor: getRandomBgColor(),
          });

        }

        localStorage.setItem("groupColorInfo", JSON.stringify(addedList));
      }
    }


    return bgColorArray;
  }


  const initialLength = 20;
  // const initialLength = 2;

  let textList;

  if (groupTalkInputList.length > 0) {
    let displayList = groupTalkInputList.slice(-1*initialLength*getMoreNum);

    let refIndex = initialLength-1;

    if (groupTalkInputList.length - initialLength*(getMoreNum-1) < initialLength) {
      refIndex = groupTalkInputList.length - (initialLength*(getMoreNum));
    }

    // console.log(refIndex, isMoreText);

    if (refIndex < 0) {
      refIndex = refIndex + initialLength;
    }
    // refIndex = initialLength -1;
    // const lsNameDataList = localStorage.getItem('lsNameDataList');

    textList = (
      <ul className="textTalk-list">
        {displayList.map((inputData, index) => {
          return (
            <div ref={index === refIndex ? ref : null} key={index}>
              <span 
                ref={(el) => (textListRef.current[inputData._id] = el)}
              >
                <GroupTalkTextItem
                  inputData={inputData}
                  userId={userId}
                  // index={index}
                  userColorList={userColorList}
                  allMemberUserIds={allMemberUserIds}
                  groupTextReactions={groupTextReactions}
                  createGroupTextReactionHandler={createGroupTextReactionHandler}
                  groupTextDeleteHandler={groupTextDeleteHandler}
                  lsNameDataList={lsNameDataList}
                  groupTextPostHandler={groupTextPostHandler}
                  isTextPosting={isTextPosting}
                  isLoading={isLoading}
                />
              </span>
            </div>
          );
        })}
      </ul>
    );
  }

  return (
    <div>
      {/* <button
        style={{position:"fixed", top:"100px", left:"200px"}}
        onClick={() => { 
          if (isMoreText) {
            setGetMoreNum(getMoreNum+1); 
          }
        }}
      >
        get-more-button {getMoreNum} {isMoreText && 'isMoreText'} 
      </button> */}

      <div
        id="text-talk"
        className="groupTalkTextList-container"
        style={!showGroupTextInputElement ? { bottom: "10px" } : {}}
      >
        {isLoading && (
          <div className="groupTalk__loader">
            <Loader />
          </div>
        )}

        {textList}
      </div>
    </div>
  );
};

export default GroupTalkTextList;
